module.exports = __webpack_public_path__ + "images/edm_social_website_x28.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/email/edm_social_website_x28.png
// module id = 869
// module chunks = 3